function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M0,105.5Z",
  transform: "translate(17.001 17)",
  fill: "#65ccb8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_46",
  "data-name": "Path 46",
  d: "M134.685,126.532c-20.454-2.162-80.451-17.193-80.451-17.193a42.234,42.234,0,0,1,0-84.468l80.244-3.746c31.675-2.534,38.01,39.852,38.01,71.62C172.489,111.5,153.34,128.5,134.685,126.532Z",
  transform: "translate(26.01 55.074)",
  fill: "#65ccb8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_47",
  "data-name": "Path 47",
  d: "M113.138,97.113C94.808,94.951,41.34,79.92,41.34,79.92a25.34,25.34,0,0,1,0-50.681l76.021-4.223c17.831-1.689,25.34,28.639,25.34,46.55C142.7,85.773,127.248,98.781,113.138,97.113Z",
  transform: "translate(38.904 67.747)",
  fill: "#65ccb8"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_17",
  "data-name": "Group 17",
  transform: "translate(71.798 109.808)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_43",
  "data-name": "Ellipse 43",
  cx: 8,
  cy: 8.5,
  rx: 8,
  ry: 8.5,
  transform: "translate(72.204 25.192)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_48",
  "data-name": "Path 48",
  d: "M20,31h8.447v8.447H20Z",
  transform: "translate(-20 -22.553)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_49",
  "data-name": "Path 49",
  d: "M24,29h8.447v8.447H24Z",
  transform: "translate(-7.106 -29)",
  fill: "#65ccb8"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M125.478,3A122.478,122.478,0,1,0,247.956,125.478,122.478,122.478,0,0,0,125.478,3ZM24.117,125.478A101.361,101.361,0,0,1,125.478,24.117a97.615,97.615,0,0,1,59.127,21.117L49.457,188.829C34.806,171.251,24.117,150.147,24.117,125.478ZM125.478,226.839a97.615,97.615,0,0,1-59.127-21.117L201.5,62.127c14.651,17.578,25.34,38.682,25.34,63.351A101.361,101.361,0,0,1,125.478,226.839Z",
  transform: "translate(-3 -3)",
  fill: "#65ccb8"
});

function SvgFlatselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flatselected",
    xmlns: "http://www.w3.org/2000/svg",
    width: 244.956,
    height: 244.956,
    viewBox: "0 0 244.956 244.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatselected);
export default __webpack_public_path__ + "static/media/flatselected.8cec0eb5.svg";
export { ForwardRef as ReactComponent };